module.exports = __webpack_public_path__ + "img/map-icon1.52cca0c5.png";